import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAccounts = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.8999 4.81861L10.5543 2.1273C10.5034 2.02546 10.4329 1.93464 10.3469 1.86003C10.2609 1.78542 10.1611 1.72849 10.0531 1.69249C9.94507 1.65648 9.83102 1.64211 9.71742 1.6502C9.60389 1.65828 9.49301 1.68867 9.39121 1.73961L3.23321 4.81861M11.8999 4.81861H3.23321M11.8999 4.81861C12.3596 4.81861 12.8007 5.00124 13.1257 5.3263C13.4508 5.65137 13.6334 6.09225 13.6334 6.55196L13.6333 7.41864M3.23321 4.81861C2.7735 4.81861 2.33275 5.00124 2.00769 5.3263C1.68262 5.65137 1.5 6.09225 1.5 6.55196V12.6187C1.5 13.0784 1.68262 13.5193 2.00769 13.8443C2.33275 14.1694 2.77363 14.352 3.23335 14.352H11.9001C12.3598 14.352 12.8007 14.1694 13.1257 13.8443C13.4508 13.5193 13.6334 13.0784 13.6334 12.6187L13.6333 11.752M13.6333 11.752C13.8632 11.752 14.0837 11.6607 14.2462 11.4982C14.4087 11.3356 14.5 11.1152 14.5 10.8853V8.28531C14.5 8.05547 14.4087 7.83499 14.2462 7.67246C14.0837 7.50993 13.8632 7.41864 13.6333 7.41864M13.6333 11.752H12.3952C11.8206 11.752 11.2695 11.5237 10.8631 11.1174C10.4568 10.7111 10.2285 10.16 10.2285 9.58532C10.2285 9.01066 10.4568 8.45957 10.8631 8.05321C11.2695 7.64692 11.8206 7.41864 12.3952 7.41864H13.6333",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgAccounts;
